var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transition"},[_c('button',{on:{"click":function($event){_vm.isActive= !_vm.isActive}}},[_vm._v("トランジション")]),_c('transition',[(_vm.isActive)?_c('div',[_vm._v("こんにちは！")]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }